import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled(motion.div)<{ $isAddedItem?: boolean }>`
    position: absolute;
    top: 8px;
    right: 8px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 22px;
    height: 22px;

    gap: 2px;
    flex-shrink: 0;

    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.1);

    transition:
        background 0.2s ease-in-out,
        border 0.2s ease-in-out;

    cursor: pointer;
    pointer-events: all;

    &:hover {
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.2);
    }

    ${({ $isAddedItem }) =>
        $isAddedItem &&
        css`
            background: #fff;
            border: 1px solid #fff;

            &:hover {
                background: #fff;
                border: 1px solid #fff;
            }
        `}
`;
